module.exports = __webpack_public_path__ + "static/media/pp-7.7ac4198d.jpg";